<script setup>
import { nextTick, ref } from 'vue';
import SLAPopoverCard from 'dashboard/components/widgets/conversation/components/SLAPopoverCard.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import Popover from 'dashboard/components-next/popover/Popover.vue';

defineProps({
  slaEvents: { type: Array, default: () => [] },
});

const popover = ref(null);
const trigger = ref(null);
const content = ref(null);
const isOpen = ref(false);

const onShow = async () => {
  isOpen.value = true;
  await nextTick();
  content.value?.focus({ preventScroll: true });
};
const onHide = () => {
  isOpen.value = false;
  if (content.value?.contains(document.activeElement))
    trigger.value?.$el?.focus();
};
const onFocusOut = event => {
  if (
    !content.value?.contains(event.relatedTarget) &&
    !trigger.value?.$el?.contains(event.relatedTarget)
  ) {
    popover.value?.hide();
  }
};
</script>

<template>
  <div
    class="flex items-center col-span-2 text-n-slate-11 justify-start md:justify-end"
  >
    <Popover
      ref="popover"
      align="start"
      content-class="!rounded-xl"
      disable-mobile-view
      @show="onShow"
      @hide="onHide"
    >
      <NextButton
        ref="trigger"
        class="!min-h-11 !rounded-xl"
        :aria-expanded="isOpen"
        link
        slate
        type="button"
        :label="$t('SLA_REPORTS.TABLE.VIEW_DETAILS')"
        @focusout="onFocusOut"
      />
      <template #content>
        <div
          ref="content"
          tabindex="-1"
          @focusout="onFocusOut"
          @keydown.esc.prevent.stop="popover?.hide()"
        >
          <SLAPopoverCard
            role="region"
            :aria-label="$t('SLA_REPORTS.TABLE.VIEW_DETAILS')"
            :sla-missed-events="slaEvents"
            :empty-message="$t('SLA_REPORTS.NO_BREACHES')"
            class="!static !w-72 max-w-[calc(100vw-2rem)] !max-h-none !overflow-visible !rounded-xl !shadow-none md:!w-96"
          />
        </div>
      </template>
    </Popover>
  </div>
</template>
